import React, { useEffect, useState } from "react";
import "../../css/ContactedModal.css";

const ContactModal = ({
  handleClose,
  project,
  displayTitle,
  contactMobile,
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (project?.about_developer) {
      setData(project?.about_developer);
    }
  }, []);

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{
          display: "block",
          background: "rgba(0, 0, 0, 0.5)",
        }}
        aria-labelledby="exampleModalLabel"
        aria-hidden="false"
      >
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="contact-modal-content">
            <div className="">
              <button
                type="button"
                className="btn-close-contact"
                onClick={handleClose}
                aria-label="Close"
              >
                <i className="fa fa-times"></i>
              </button>
              <div
                className="builder-info1 "
                data-aos="fade-up"
                data-aos-duration="500"
              >
                <div className="builderimg">
                  {data.builder_logo ? (
                    <img
                      src={`${data.builder_logo}`}
                      alt="Project Logo"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = "none";
                        const nextDiv = e.target.nextSibling;
                        if (nextDiv) nextDiv.style.display = "flex";
                      }}
                    />
                  ) : null}

                  {(data?.builder_name || data?.name) && (
                    <div
                      className="projectFirstLetter"
                      style={{ display: data?.builder_logo ? "none" : "flex" }}
                    >
                      {(data?.builder_name || data?.name)
                        ?.charAt(0)
                        .toUpperCase()}
                    </div>
                  )}
                </div>

                <div
                  className="builder-info-detail-contacted justify-content-between"
                  style={{ border: "none", width: "100%" }}
                >
                  <div className="binfotopbx">
                    <h5>
                      {project?.pg_name ||
                        data?.builder_name ||
                        displayTitle ||
                        (data?.specifications?.sizes?.[0] ||
                          project?.sizes?.[0]) +
                          " Sq.Ft. " +
                          (project?.property_type || data?.property_type)}
                    </h5>
                    <h5 className="mobno">{contactMobile}</h5>
                  </div>

                  <div className="binfocallicon">
                    <a href={`tel:${contactMobile}`}>
                      <i className="fa fa-phone" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div
                className="alert-detail-1 mt-3"
                data-aos="fade-up"
                data-aos-duration="700"
              >
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                <p style={{ textAlign: "justify" }}>
                  Seller details are now available in the contacted properties
                  section of the profile page
                </p>
              </div>
              <div
                className="alert-detail-2 mt-2"
                data-aos="fade-up"
                data-aos-duration="1500"
              >
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                <p
                  style={{
                    marginTop: "0",
                    marginBottom: "0",
                    fontSize: "11px",
                  }}
                >
                  <strong>Do not give any advance money</strong> without
                  visiting the property or closing the agreement
                </p>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactModal;
